export enum MaintenanceOutageType {
  maintenance = 'maintenance',
  outage = 'outage',
}
